<template>
  <modal :front="true" :opened="opened" no-pad="true">
    <div ref="conteudo" class="height-95 pt-3">
      <div v-if="entregadores && entregadores.length" class="container-fluid pb-2">
        <modal-menu v-if="proprios.length && plataformas.length" :menus="menus" :selected="menu" @changeMenu="trocarMenu"/>
        <template v-if="!proprios.length || !plataformas.length">
          <h6 class="font-weight-bold mb-3 text-center text-dark">Selecione o entregador</h6>
          <hr>
        </template>
        <div class="mb-3">
          <input ref="pesquisa" v-model="termo" class="form-control" placeholder="Buscar entregador" type="search"
                 @keyup="pesquisar()" @search="pesquisar(true)" @keydown.esc="fechar()">
        </div>
        <a class="text-decoration-none list_entregador" href="javascript:" @click="selecionar(null)">
          <div class="px-2 py-3 d-flex justify-content-between align-items-center">
            <div>{{ selecionado ? 'Desvincular' : 'Não vincular' }}</div>
          </div>
        </a>
        <a v-for="(entregador, index) in filtrados" :id="`entregador${index}`" :key="entregador.id_usuario"
           :class="{'selected': String(selecionado) === String(entregador.id_usuario)}" class="text-decoration-none list_entregador"
           href="javascript:" @click="selecionar(entregador)">
          <div class="px-2 py-3 d-flex justify-content-between align-items-center">
            <div><img class="mr-1" src="../../assets/icons/helmet.svg"> {{ entregador.nome }}</div>
            <i v-if="String(selecionado) === String(entregador.id_usuario)" class="fa fa-check mr-2"></i>
          </div>
        </a>
      </div>
      <div v-else class="container-fluid pb-2 text-center">
        <h6 class="font-weight-bold mb-3 text-dark">Selecione o Entregador</h6>
        <hr>
        <p class="alert alert-warning">
          Para cadastrar os entregadores, acesse o Portal, vá até o menu <b>Usuários</b> e clique em <b>Entregadores</b>.
        </p>
        <router-link to="/portal" class="btn text-secondary">Cadastrar</router-link>
      </div>
    </div>
    <div class="border-top p-2"><button class="btn btn-dark p-3" @click="fechar">Voltar</button></div>
  </modal>
</template>
<script>
import ModalMenu from "@/components/commons/ModalMenu";
import Modal from "@/components/gestor/ModalGestor";
export default {
  name: 'ModalEntregador',
  components: { Modal, ModalMenu },
  props: { multiplosPedidos: Boolean, opened: Boolean, selecionado: { default: null } },
  data() { return { termo: '', filtrados: [], menu: 1 }; },
  computed: {
    entregadores() { return (this.$store.state.dataUser.entregadores || []).filter(e => !this.multiplosPedidos || e.multiplos_pedidos !== false); },
    proprios() { return this.entregadores.filter(e => !Number(e.id_auth)); },
    plataformas() { return this.entregadores.filter(e => Number(e.id_auth)); },
    menus() { return [{ nome: 'Próprios', active: true }, { nome: 'Plataformas', active: true }]; },
    grupo() { return this.menu === 2 ? this.plataformas : this.proprios; }
  },
  watch: {
    opened(aberto) {
      if (!aberto) return;
      this.menu = this.plataformas.some(e => String(e.id_usuario) === String(this.selecionado)) || !this.proprios.length ? 2 : 1;
      this.termo = '';
      this.pesquisar();
      this.$nextTick(() => { if (this.$refs.pesquisa) this.$refs.pesquisa.focus(); });
    },
    entregadores: { immediate: true, handler() {
      if (!this.grupo.length) this.menu = this.proprios.length ? 1 : 2;
      this.pesquisar();
    } }
  },
  methods: {
    fechar() { this.$emit('fechar'); },
    trocarMenu(menu) { this.menu = menu; this.termo = ''; this.pesquisar(); },
    pesquisar(selecionarUnico) {
      const termo = this.termo.trim().toLowerCase();
      this.filtrados = termo ? this.grupo.filter(e => e.nome.toLowerCase().includes(termo)) : this.grupo.slice();
      if (selecionarUnico && this.filtrados.length === 1) this.selecionar(this.filtrados[0]);
    },
    selecionar(entregador) { this.$emit(entregador && Number(entregador.id_auth) ? 'logistica' : 'selecionar', entregador); }
  }
};
</script>
<style scoped>
.list_entregador {
  display: block;
  margin-bottom: 8px;
  color: var(--dark);
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.list_entregador.selected {
  border-color: var(--success);
}
</style>
